export enum ImageHeights {
    LOOKS_DESKTOP = 806,
    LOOKS_MOBILE = 606,
}

export const contentfulHeightFormatter = (src: string, height: number, quality: number = 90) => {
    if (!src) {
        return '';
    }
    return `${src}?h=${height}&fm=jpg&q=${quality}`;
};

export const contentfulWidthFormatter = (src: string, width: number, quality: number = 90) => {
    return {
        webpSrc: `${src}?w=${width}&fm=webp&q=${quality}`,
        jpegSrc: `${src}?w=${width}&fm=jpg&q=${quality}`,
    };
};
